module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-regular-400.faa0b37d.ttf";